"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  "*": {
    "*": {
      "tagName": "span"
    },
    "sequence": {
      "tagName": "section"
    }
  },
  "paragraph": {
    "*": {
      "tagName": "p"
    }
  },
  "mark": {
    "*": {
      "tagName": "span"
    },
    "chapter": _ref => {
      var {
        atts
      } = _ref;
      return {
        classList: ['mark', 'chapter', "chapter-".concat(atts.number)],
        id: "chapter-".concat(atts.number)
      };
    }
  },
  "graft": {
    "heading": {
      "tagName": "div"
    },
    "title": {
      "tagName": "div"
    },
    "introduction": {
      "tagName": "div"
    }
  }
};
exports.default = _default;